import * as React from "react";
import * as ReactDOM from "react-dom";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Home from "./Home";
import CategoryList from "./categories/CategoryList";
import Reports from "./reports/Reports";
import IncomeReport from "./reports/IncomeReport";
import ExpenseReport from "./reports/ExpenseReport";
import { SettingsProvider } from './Context/SettingContext'; 

const router = createHashRouter([
    { path: "/", element: <Home /> },
    { path: "/category", element: <CategoryList /> },
    { path: "/report", element: <Reports /> },
    { path: "/income-report", element: <IncomeReport /> },
    { path: "/expense-report", element: <ExpenseReport /> },
]);

ReactDOM.createRoot(document.getElementById("devsaccounting_admin")).render(
    <React.StrictMode>
        <SettingsProvider> 
            <RouterProvider router={router} />
        </SettingsProvider>
    </React.StrictMode>
);
